import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Input } from '../../../../common/html/input'
import { Loading } from '../../../../common/loading'
import { isInValidValue } from '../../../../helpers/value'
import classes from '../../../index.module.scss'
import {
  selectInvoiceReceivingForm,
  setInvoiceReceivingForm,
} from '../../store/slice'
import { checkEmailValid, checkPhoneValid } from '../helper'
import { INFORMATION_INPUTS, INVOICE_RECEIVE_FIELDS } from './constants'

export const InvoiceReceivingInfo = ({
  isValid,
  setIsValid,
  userProfile,
  loading,
}) => {
  const dispatch = useDispatch()

  const form = useSelector(selectInvoiceReceivingForm)

  const setForm = (form) => {
    dispatch(setInvoiceReceivingForm(form))
  }

  const getTextInvalid = (key) => {
    let textInvalid = ''
    if (key === INVOICE_RECEIVE_FIELDS.PHONE) {
      textInvalid = 'domesticSearchPreview.INVALID_PHONE'
    }

    if (key === INVOICE_RECEIVE_FIELDS.EMAIL) {
      textInvalid = 'domesticSearchPreview.INVALID_EMAIL'
    }

    return typeof form[key] === 'string' && !!form[key].trim()
      ? textInvalid
      : 'userProfile.REQUIRED_FIELD'
  }

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (!!eventValue.trim()) {
      setIsValid({
        ...isValid,
        [key]: true,
      })
    }

    if (key === INVOICE_RECEIVE_FIELDS.PHONE) {
      if (!!eventValue.trim()) {
        if (!checkPhoneValid(eventValue)) {
          return
        }
      }
    }

    if (key === INVOICE_RECEIVE_FIELDS.EMAIL) {
      if (!!eventValue.trim()) {
        setIsValid({
          ...isValid,
          [key]: checkEmailValid(eventValue),
        })
      } else {
        setIsValid({
          ...isValid,
          [key]: true,
        })
      }
    }

    setForm({ ...form, [key]: eventValue })
  }

  useEffect(() => {
    setForm({
      [INVOICE_RECEIVE_FIELDS.CUSTOMER_NAME]: userProfile?.fullName,
      [INVOICE_RECEIVE_FIELDS.EMAIL]: userProfile?.email,
      [INVOICE_RECEIVE_FIELDS.PHONE]: userProfile?.companyPhone,
      [INVOICE_RECEIVE_FIELDS.TAX_CODE]: userProfile?.companyTaxCode,
      [INVOICE_RECEIVE_FIELDS.COMPANY_ADDRESS]: userProfile?.companyAddress,
      [INVOICE_RECEIVE_FIELDS.COMPANY_NAME]: userProfile?.companyName,
    })
  }, [])

  return loading ? (
    <Loading />
  ) : (
    <Element
      style={{
        backgroundColor: '#FFFFFF',
      }}
      className={classes.invoiceInfoContainer}
    >
      <Element className={['fw600'].join(' ')} style={{ fontSize: 14 }}>
        <Translate value="userManagement.paymentInformation.INVOICE_RECEIVING" />
      </Element>
      <div className={classes.invoiceForm}>
        {INFORMATION_INPUTS.map((item) => {
          return (
            <Input
              noControl
              key={item.key}
              placeHolder={item.placeHolder}
              isShowLabel
              isShowIcon={false}
              containerStyle={
                !isValid[item.key] && !isInValidValue(isValid[item.key])
                  ? { marginBottom: 30 }
                  : { marginBottom: 20 }
              }
              isValid={isValid[item.key]}
              textInvalid={getTextInvalid(item.key)}
              onChange={(e) => onChange(item.key, e)}
              value={form[item.key] || ''}
              styleLabel={{ backgroundColor: '#FFFFFF' }}
            />
          )
        })}
      </div>
      <Element
        className={`mt1 ${classes.note}`}
        style={{ backgroundColor: '#F8E7E9' }}
      >
        <Translate value="userManagement.paymentInformation.NOTE" />
      </Element>
    </Element>
  )
}
